<template>
  <div id="contenedor-eliminar-deduccion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar deducción </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la deducción "{{deduccionEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarDeduccion"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
Eliminar deduccion
  color="error"
  :disabled="!formularioValido || enviandoFormulario"
  @click="mixEliminarDeduccion">
<script>
import mixCatalogoDeducciones from './mixCatalogoDeducciones';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarDeduccion',
  mixins: [mixCatalogoDeducciones],
  props: {
    deduccionEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
